import {Component, Input, OnInit} from '@angular/core';
import {ApplicantRequestService} from '../../../service/applicant-request.service';

@Component({
  selector: 'app-card-preview',
  templateUrl: './card-preview.component.html',
  styleUrls: ['./card-preview.component.scss']
})
export class CardPreviewComponent implements OnInit {
  @Input()applicationId: number;
  isLoading: boolean = false;

  constructor(private applicantRequestService: ApplicantRequestService) { }

  ngOnInit() {
  }



  view() {
    this.isLoading = true;
    const mynumber=this.applicationId.toString();
    this.applicantRequestService.cardPreview1(mynumber).subscribe(
      (data: any) => {
        const file = new Blob([data], {type: 'application/pdf'});
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL,"_blank",  "width=800,height=400");

      },
      error => {
        this.isLoading = false;
        console.log(error);
      }
    );
  }

}
